import { router } from "@inertiajs/react"

window.addEventListener("popstate", (event) => {
  event.stopImmediatePropagation()

  router.visit(window.location.href, {
    preserveState: false,
    preserveScroll: false,
    replace: true
  })
})
